<!-- <ng-container class="col-md-6 col-sm-12 student-input" *ngIf="!props.isHidden">
  <label class="form-control-label">
    {{ props.label }}
    <span *ngIf="props.required">*</span>
  </label>
  <ng-select #ngSelect
    class="input-group"
    [selectableGroup]="true"
    [selectableGroupAsModel]="false"
    bindLabel="{{ props.bindLabel }}"
    formControlName="{{ props.field_Name }}"
    bindValue="{{ props.bindValue }}"
    appendTo="body"
    placeholder="Select"
    [readonly]="props.readOnly"
    [multiple]="true"
    [searchable]="true"
    [clearable]="true"
    (change)="onMaterialGroupChange($event)"
    [items]="options">
    <ng-template ng-option-tmp let-item="item" let-item$="item$">
      <div *ngIf="item.student_id === 'selectAll'" 
           class="select-all-option"
           (click)="$event.stopPropagation(); onSelectAllChange({ target: { checked: !areAllSelected() } }, ngSelect)">
        <input id="select-all" 
               type="checkbox" 
               [checked]="item$.selected"
               (click)="$event.stopPropagation()"
               />
        <span>{{ item[props.bindLabel] }}</span>
      </div>
      <div *ngIf="item.student_id !== 'selectAll'" class="option-item">
        <input id="item-{{ item.student_id }}" 
               type="checkbox" 
               [checked]="item$.selected"
               (click)="$event.stopPropagation()"
               />
        <span>{{ item[props.bindLabel] }}</span>
      </div>
    </ng-template>
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngFor="let item of items">
        <span class="ng-value-label">{{ item[props.bindLabel] }}</span>
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      </div>
    </ng-template>
  </ng-select>
  <sm-error [control]="formcontrol"></sm-error>
</ng-container> -->

<ng-container class="col-md-6 col-sm-12 student-input" *ngIf="!props.isHidden">
  <label class="form-control-label">
    {{ props.label }}
    <span *ngIf="props.required">*</span>
  </label>
  <ng-select #ngSelect
    class="input-group"
    [selectableGroup]="true"
    [selectableGroupAsModel]="false"
    bindLabel="{{ props.bindLabel }}"
    formControlName="{{ props.field_Name }}"
    bindValue="{{ props.bindValue }}"
    appendTo="body"
    placeholder="Select"
    [readonly]="props.readOnly"
    [multiple]="true"
    [searchable]="true"
    [clearable]="true"
    (change)="onMaterialGroupChange($event)"
    (keydown)="handleKeyDown($event, ngSelect)"
    [items]="options">
    <ng-template ng-option-tmp let-item="item" let-item$="item$">
      <div *ngIf="item.student_id === 'selectAll'" 
           class="select-all-option"
           (click)="$event.stopPropagation(); onSelectAllChange($event, ngSelect)"
           (keydown)="handleKeyDown($event, ngSelect)"
           tabindex="0">
        <input id="select-all" 
               type="checkbox" 
               [checked]="areAllSelected()"
               (click)="$event.stopPropagation(); onSelectAllChange($event, ngSelect)"
               />
        <span>{{ item[props.bindLabel] }}</span>
      </div>
      <div *ngIf="item.student_id !== 'selectAll'" class="option-item">
        <input id="item-{{ item.student_id }}" 
               type="checkbox" 
               [checked]="item$.selected"
               />
        <span>{{ item[props.bindLabel] }}</span>
      </div>
    </ng-template>
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngFor="let item of items">
        <span class="ng-value-label">{{ item[props.bindLabel] }}</span>
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      </div>
    </ng-template>
  </ng-select>
  <sm-error [control]="formcontrol"></sm-error>
</ng-container>